

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_160_1_easing";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_160_1_easing__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"speed-fast-1":"100ms","speed-fast-2":"150ms","speed-medium-1":"200ms","speed-medium-2":"300ms","speed-slow-1":"400ms","speed-slow-2":"500ms","speed-slow-02":"600ms","ease-1":"cubic-bezier(0.23, 1, 0.32, 1)","ease-2":"cubic-bezier(0.25, 0.46, 0.45, 0.94)","ease-3":"cubic-bezier(0, 0, 0.2, 1)","ease-4":"cubic-bezier(0.4, 0.0, 1, 1)","ease-5":"cubic-bezier(0.81, 0, 1, 1)","ease-6":"cubic-bezier(0.18, 0.89, 0.32, 1.28)","ease-7":"cubic-bezier(0.19, 1, 0.22, 1)","ease-8":"ease-in-out","ease-9":"linear"}; 
export var vars = {}; 




